export default class SaveAbsenceResponse {
    public success: boolean = false;
    public errorMessage: string = "";
    public workOrderId?: string | null;
}
